import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function HomeNavbar() {
  const { user, loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [authLoading, setAuthLoading] = useState(false);

  const handleLogin = async () => {
    setAuthLoading(true);
    try {
      await loginWithGoogle();
      navigate("/dashboard");
    } catch (e) {
      console.error(e);
    } finally {
      setAuthLoading(false);
    }
  };

  return (
    <header className="home-nav">
      <div className="home-nav-inner">
        <div className="home-logo">
          <img src="/creatorcomment-logo.png" alt="CreatorComment Logo" className="logo-img" />
        </div>
        <nav className="home-nav-links">
          <a href="/#features">Features</a>
          <a href="/#pricing">Pricing</a>
          <a href="/#testimonials">Reviews</a>
          <a href="/contact">Contact</a>
        </nav>
        <button className="btn-nav-cta" onClick={handleLogin} disabled={authLoading}>
          {authLoading ? "..." : "Get Started Free →"}
        </button>
      </div>
    </header>
  );
}